@if (dealDetails$ | async; as dealDetails) {
  <mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'deal-details'">
    <mat-card-header class="detail-card-header">
      <mat-card-title data-test="title">Deal Details</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
      <form [formGroup]="dealDetailsForm">
        <div class="key-value-pair-section">
          <div class="key-value-pair-column">
            <div>
              <div class="key-value-pair">
                <div class="key-value-item">Number of Funds</div>
                <div class="key-value-item">{{dealDetails.dealFunds.dealFundRecords.length}}</div>
              </div>
              <div class="key-value-pair">
                <div class="key-value-item">Total Deal Size</div>
                <div class="key-value-item">{{dealDetails.dealFunds.totalAdjustedCommitment | traceableFormat}}</div>
              </div>
              <div class="key-value-pair">
                <div class="key-value-item">Total NAV</div>
                <div class="key-value-item">{{dealDetails.dealFunds.totalNavBuyerStake | traceableFormat}}</div>
              </div>
              <div class="key-value-pair">
                <div class="key-value-item">Bid Price</div>
                <div class="key-value-item">{{dealDetails.dealFunds.totalBidPriceBuyerStake | traceableFormat}}</div>
              </div>
              <div class="key-value-pair">
                <div class="key-value-item">Discount to NAV</div>
                <div class="key-value-item">{{dealDetails.dealFunds.totalDiscountToNav | traceableFormat}}</div>
              </div>
            </div>
          </div>
          <div class="key-value-pair-column">
            <div>
              @if (seller$ | async; as seller) {
                <div class="key-value-pair">
                  <div class="key-value-item">Seller</div>
                  <div class="key-value-item">{{seller.name | traceableFormat}}</div>
                </div>
              }
              <valumize-mergeable-input
                  [label]="'Source'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [value]="dealDetails.deal.source"
                  [control]="dealDetailsForm.controls.source">
              </valumize-mergeable-input>
              <valumize-mergeable-select-code
                  [label]="'Type of Process'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [codeTable]="codeTableProcessType"
                  [code]="dealDetails.deal.processType"
                  [control]="dealDetailsForm.controls.processType">
              </valumize-mergeable-select-code>
              <valumize-mergeable-input
                  [label]="'Deal Captain'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [value]="dealDetails.deal.dealCaptain"
                  [control]="dealDetailsForm.controls.dealCaptain">
              </valumize-mergeable-input>
            </div>
          </div>
          <div class="key-value-pair-column">
            <div>
              <valumize-mergeable-select-code
                  [label]="'Currency'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [codeTable]="codeTableCurrency"
                  [code]="dealDetails.deal.currencyIso"
                  [control]="dealDetailsForm.controls.currencyIso"
                  [searchable]="true"
                  [showCode]="true"
                  [isMandatory]="true">
              </valumize-mergeable-select-code>
              <valumize-mergeable-number-input
                  [label]="'Secondary Management Fee'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [value]="dealDetails.deal.secondaryManagementFee"
                  [control]="dealDetailsForm.controls.secondaryManagementFee"
                  [warning]="feeWarning('secondaryManagementFee', 5)"
                  [type]="'percent'">
              </valumize-mergeable-number-input>
              <valumize-mergeable-number-input
                  [label]="'Secondary Carry'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [value]="dealDetails.deal.secondaryCarry"
                  [control]="dealDetailsForm.controls.secondaryCarry"
                  [warning]="feeWarning('secondaryCarry', 30)"
                  [type]="'percent'">
              </valumize-mergeable-number-input>
              <valumize-mergeable-number-input
                  [label]="'Secondary Hurdle'"
                  [isEditable]="dealDetails.dealDetailsIsEditable"
                  [value]="dealDetails.deal.secondaryHurdle"
                  [control]="dealDetailsForm.controls.secondaryHurdle"
                  [warning]="feeWarning('secondaryHurdle', 20)"
                  [type]="'percent'">
              </valumize-mergeable-number-input>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions class="detail-card-actions">
      @if (!dealDetails.dealDetailsIsEditable) {
        <button (click)="edit()"
          [disabled]="(isEditDisabled$ | async)!"
          color="primary"
          data-test="edit-button"
          mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      }
      @if (dealDetails.dealDetailsIsEditable) {
        <button (click)="save(dealDetails.deal)"
          [disabled]="dealDetailsForm.invalid"
          color="primary"
          data-test="save-button"
          mat-icon-button>
          <mat-icon>save</mat-icon>
        </button>
      }
      @if (dealDetails.dealDetailsIsEditable) {
        <button (click)="cancel()"
          color="primary"
          data-test="cancel-button"
          mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      }
      <valumize-card-comments-button [commentSlug]="'deal-details'"></valumize-card-comments-button>
    </mat-card-actions>
  </mat-card>
}

